export default "__VITE_ASSET__2a0d069b__"